/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function() {
    'use strict';
    angular.module('BlurAdmin.theme', [
        'chart.js',
        /*'toastr',
        'angular-chartist',
        'angular.morris-chart',*/
        'textAngular',
        'BlurAdmin.theme.components',
        'BlurAdmin.theme.inputs'
    ]);
    angular.module('BlurAdmin', [
        'ngAnimate',
        'ui.bootstrap',
        'ui.router',
        'ngTouch',
        /*'toastr',
        'ui.sortable',
        'smart-table',
        "xeditable",
        'ngJsTree',
        'angular-progress-button-styles',*/
        'ui.slimscroll',
        'BlurAdmin.theme'
    ]);

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  themeLayoutSettings.$inject = ["baConfig"];
  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  themeRun.$inject = ["$timeout", "$rootScope", "layoutPaths", "preloader", "$q", "baSidebarService", "themeLayoutSettings"];
  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'content/theme/assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + '/profile/',
        amMap: 'assets/img/theme/vendor/ammap/dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  configProvider.$inject = ["colorHelper"];
  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
    /*primary: '#209e91', valeur par défaut : verte*/
  var colorScheme = {
    primary: '#e65100',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function() {
    'use strict';

    config.$inject = ["baConfigProvider", "colorHelper", "$provide"];
    chartJsConfig.$inject = ["ChartJsProvider", "baConfigProvider"];
    uiViewScrollDecorator.$inject = ["$delegate", "$anchorScroll", "baUtil"];
    angular.module('BlurAdmin.theme')
        .config(config)
        .config(chartJsConfig);

    /** @ngInject */
    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            legend: {
                display: false,
                position: 'left',
                labels: {
                    fontColor: layoutColors.defaultText
                }
            }
        });
        /*nfigure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });*/
    }


    /** @ngInject */
    function config(baConfigProvider, colorHelper, $provide) {
        $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
        baConfigProvider.changeTheme({
            blur: false
        });
        //
        baConfigProvider.changeColors({
            //default: '#4e4e55',
            default: '#e65100',
            defaultText: '#e2e2e2',
            dashboard: {
                white: '#ffffff',
            },
        });
    }

    /** @ngInject */
    function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
        return function(uiViewElement) {
            if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
                $anchorScroll();
            } else {
                $delegate(uiViewElement);
            }
        };
    }
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  stopableInterval.$inject = ["$window"];
  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  preloader.$inject = ["$q"];
  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        
          d.resolve();
        /*AmCharts.ready(function(){
        });*/
        return d.promise;
      }
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  fileReader.$inject = ["$q"];
  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    baProgressModal.$inject = ["$uibModal"];
    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  profilePicture.$inject = ["layoutPaths"];
  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      if(angular.isUndefined(input)||input===null){
        return layoutPaths.images.profile+"no-photo.png";
      }else{
        return layoutPaths.images.profile + input + '.' + ext;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  kameleonImg.$inject = ["layoutPaths"];
  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  appImage.$inject = ["layoutPaths"];
  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  zoomIn.$inject = ["$timeout", "$rootScope"];
  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  ionSlider.$inject = ["$timeout"];
  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

(function () {
  'use strict';

  autoFocus.$inject = ["$timeout", "$parse"];
  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function() {
    "use strict";
    angular.module('BlurAdmin.theme').directive('angucomplete', dir);
    dir.$inject = ["$parse", "$http", "$sce", "$timeout"];

    function dir($parse, $http, $sce, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                "id": "@id",
                "placeholder": "@placeholder",
                "selectedObject": "=selectedobject",
                "url": "@url",
                "dataField": "@datafield",
                "titleField": "@titlefield",
                "descriptionField": "@descriptionfield",
                "imageField": "@imagefield",
                "imageUri": "@imageuri",
                "inputClass": "@inputclass",
                "userPause": "@pause",
                "localData": "=localdata",
                "searchFields": "@searchfields",
                "minLengthUser": "@minlength",
                "matchClass": "@matchclass"
            },
            template: '<div class="angucomplete-holder"><input name="{{id}}" autocomplete="false" id="{{id}}_value" ng-model="searchStr" type="text" placeholder="{{placeholder}}" class="{{inputClass}}" onmouseup="this.select();" ng-focus="resetHideResults()" ng-blur="hideResults()" /><div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-if="showDropdown"><div class="angucomplete-searching" ng-show="searching">En cours...</div><div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)">Elément introuvable</div><div class="angucomplete-row" ng-repeat="result in results" ng-mousedown="selectResult(result)" ng-mouseover="hoverRow()" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}"><div ng-if="imageField" class="angucomplete-image-holder"><img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="angucomplete-image"/><div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div></div><div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div><div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div><div ng-if="result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div></div></div></div>',

            link: function($scope, elem, attrs) {
                $scope.lastSearchTerm = null;
                $scope.currentIndex = null;
                $scope.justChanged = false;
                $scope.searchTimer = null;
                $scope.hideTimer = null;
                $scope.searching = false;
                $scope.pause = 500;
                $scope.minLength = 3;
                $scope.searchStr = null;

                if ($scope.minLengthUser && $scope.minLengthUser != "") {
                    $scope.minLength = $scope.minLengthUser;
                }

                if ($scope.userPause) {
                    $scope.pause = $scope.userPause;
                }

                $scope.isNewSearchNeeded = function(newTerm, oldTerm) {
                    return newTerm.length >= $scope.minLength && newTerm != oldTerm
                }

                $scope.processResults = function(responseData, str) {
                    if (responseData && responseData.length > 0) {
                        $scope.results = [];

                        var titleFields = [];
                        if ($scope.titleField && $scope.titleField != "") {
                            titleFields = $scope.titleField.split(",");
                        }

                        for (var i = 0; i < responseData.length; i++) {
                            // Get title variables
                            var titleCode = [];

                            for (var t = 0; t < titleFields.length; t++) {
                                titleCode.push(responseData[i][titleFields[t]]);
                            }

                            var description = "";
                            if ($scope.descriptionField) {
                                description = responseData[i][$scope.descriptionField];
                            }

                            var imageUri = "";
                            if ($scope.imageUri) {
                                imageUri = $scope.imageUri;
                            }

                            var image = "";
                            if ($scope.imageField) {
                                image = imageUri + responseData[i][$scope.imageField];
                            }

                            var text = titleCode.join(' ');
                            if ($scope.matchClass) {
                                var re = new RegExp(str, 'i');
                                var strPart = text.match(re)[0];
                                text = $sce.trustAsHtml(text.replace(re, '<span class="' + $scope.matchClass + '">' + strPart + '</span>'));
                            }

                            var resultRow = {
                                title: text,
                                description: description,
                                image: image,
                                originalObject: responseData[i]
                            }

                            $scope.results[$scope.results.length] = resultRow;
                        }


                    } else {
                        $scope.results = [];
                    }
                }

                $scope.searchTimerComplete = function(str) {
                    // Begin the search

                    if (str.length >= $scope.minLength) {
                        if ($scope.localData) {
                            var searchFields = $scope.searchFields.split(",");

                            var matches = [];

                            for (var i = 0; i < $scope.localData.length; i++) {
                                var match = false;

                                for (var s = 0; s < searchFields.length; s++) {
                                    match = match || (typeof $scope.localData[i][searchFields[s]] === 'string' && typeof str === 'string' && $scope.localData[i][searchFields[s]].toLowerCase().indexOf(str.toLowerCase()) >= 0);
                                }

                                if (match) {
                                    matches[matches.length] = $scope.localData[i];
                                }
                            }

                            $scope.searching = false;
                            $scope.processResults(matches, str);

                        } else {
                            $http.get($scope.url + str, {}).
                            success(function(responseData, status, headers, config) {
                                $scope.searching = false;
                                $scope.processResults((($scope.dataField) ? responseData[$scope.dataField] : responseData), str);
                            }).
                            error(function(data, status, headers, config) {
                                console.log("error");
                            });
                        }
                    }
                }

                $scope.hideResults = function() {
                    $scope.hideTimer = $timeout(function() {
                        $scope.showDropdown = false;
                    }, $scope.pause);
                };

                $scope.resetHideResults = function() {
                    if ($scope.hideTimer) {
                        $timeout.cancel($scope.hideTimer);
                    };
                };

                $scope.hoverRow = function(index) {
                    $scope.currentIndex = index;
                }

                $scope.keyPressed = function(event) {
                    if (!(event.which == 38 || event.which == 40 || event.which == 13)) {
                        if (!$scope.searchStr || $scope.searchStr == "") {
                            $scope.showDropdown = false;
                            $scope.lastSearchTerm = null
                        } else if ($scope.isNewSearchNeeded($scope.searchStr, $scope.lastSearchTerm)) {
                            $scope.lastSearchTerm = $scope.searchStr
                            $scope.showDropdown = true;
                            $scope.currentIndex = -1;
                            $scope.results = [];

                            if ($scope.searchTimer) {
                                $timeout.cancel($scope.searchTimer);
                            }

                            $scope.searching = true;

                            $scope.searchTimer = $timeout(function() {
                                $scope.searchTimerComplete($scope.searchStr);
                            }, $scope.pause);
                        }
                    } else {
                        event.preventDefault();
                    }
                }

                $scope.selectResult = function(result) {
                    if ($scope.matchClass) {
                        result.title = result.title.toString().replace(/(<([^>]+)>)/ig, '');
                    }
                    $scope.searchStr = $scope.lastSearchTerm = result.title;
                        $scope.selectedObject = result;
                    /*if (result !== null) {
                        $scope.selectedObject = result;
                    } else {
                        $scope.selectedObject = $scope.searchStr;
                    }*/
                    $scope.showDropdown = false;
                    $scope.results = [];
                    //$scope.$apply();
                }

                var inputField = elem.find('input');

                inputField.on('keyup', $scope.keyPressed);

                elem.on("keyup", function(event) {
                    if (event.which === 40) {
                        if ($scope.results && ($scope.currentIndex + 1) < $scope.results.length) {
                            $scope.currentIndex++;
                            $scope.$apply();
                            event.preventDefault;
                            event.stopPropagation();
                        }

                        $scope.$apply();
                    } else if (event.which == 38) {
                        if ($scope.currentIndex >= 1) {
                            $scope.currentIndex--;
                            $scope.$apply();
                            event.preventDefault;
                            event.stopPropagation();
                        }

                    } else if (event.which == 13) {
                        if ($scope.results && $scope.currentIndex >= 0 && $scope.currentIndex < $scope.results.length) {
                            $scope.selectResult($scope.results[$scope.currentIndex]);
                            $scope.$apply();
                            event.preventDefault;
                            event.stopPropagation();
                        } else {
                            $scope.results = [];
                            $scope.$apply();
                            event.preventDefault;
                            event.stopPropagation();
                        }

                    } else if (event.which == 27) {
                        $scope.results = [];
                        $scope.showDropdown = false;
                        $scope.$apply();
                    } else if (event.which == 8) {
                        $scope.selectedObject = null;
                        $scope.$apply();
                    }
                });

            }
        };
    }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  animatedChange.$inject = ["$timeout"];
  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', ['josdaviApp']);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    progressBarRound.$inject = ["baProgressModal"];
    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopCtrl',
      controllerAs:'vm'
    };
  }

})();
(function() {
    'use strict';

    angular
        .module('BlurAdmin.theme.components')
        .controller('PageTopCtrl', PageTopCtrl);

    PageTopCtrl.$inject = ['$state','$scope', 'Auth', 'Principal', "Account", 'ProfileService', 'LoginService'];

    function PageTopCtrl($state,$scope, Auth, Principal, Account, ProfileService, LoginService) {
        var vm = this;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
        vm.account=null;

        vm.login = login;
        vm.logout = logout;
        vm.$state = $state;
        vm.checkAccount=checkAccount;
        vm.checkAccount();       

        $scope.$on('onLogoutSuccess', function(){
            vm.isAuthenticated = false;
           // vm.account=null;
        });        

        $scope.$on('onLoginSuccess', function(){
            vm.isAuthenticated = true;
            vm.checkAccount();
            console.log(vm.account);
        });        

        function login() {
            LoginService.open();
        }

        function logout() {
            Auth.logout();
            $state.go('home');
        }

        function checkAccount(){
            Account.get().$promise
            .then(function(account) {
                vm.isAuthenticated = (angular.isDefined(account) && account !==null && account.data!==null);
                vm.account=account;    
            })
            .catch(function() {
                vm.isAuthenticated = false;
            });
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  MsgCenterCtrl.$inject = ["$scope", "$sce"];
  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    /*
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };*/
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  contentTop.$inject = ["$location", "$state"];
  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
(function() {
  'use strict';

  baWizardCtrl.$inject = ["$scope"];
  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  baSidebarToggleMenu.$inject = ["baSidebarService"];
  baSidebarCollapseMenu.$inject = ["baSidebarService"];
  BaSidebarTogglingItemCtrl.$inject = ["$scope", "$element", "$attrs", "$state", "baSidebarService"];
  baUiSrefTogglingSubmenu.$inject = ["$state"];
  baUiSrefToggler.$inject = ["baSidebarService"];
  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    BaSidebarCtrl.$inject = ["$rootScope", "$scope", "baSidebarService", "Account"];
    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($rootScope, $scope, baSidebarService, Account) {

        loadSidebar();
        $scope.hoverItem = function($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function() {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });

        $scope.$on('onLogoutSuccess', function(){
            loadSidebar();
        });        

        $scope.$on('onLoginSuccess', function(){
            loadSidebar();
        });

        function loadSidebar() {
          $rootScope.$menuItems = [];
            Account.get().$promise
                .then(function(account) {
                    $rootScope.$menuItems = baSidebarService.getMenuItems(account.data);
                    $scope.defaultSidebarState = $scope.$menuItems[0].stateRef;
                })
                .catch(function() {
                    $rootScope.$menuItems = baSidebarService.getMenuItems(null);
                    $scope.defaultSidebarState = angular.isDefined($rootScope.$menuItems[0]) && $rootScope.$menuItems[0].stateRef;
                });
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function() {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = ["$rootScope", "$state", "layoutSizes", function($rootScope, $state, layoutSizes) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();
                this.getMenuItems = function(account) {
                    var states = defineMenuItemStates(account);
                    var menuItems = states.filter(function(item) {
                        return item.level === 0;
                    });

                    menuItems.forEach(function(item) {
                        var children = states.filter(function(child) {
                            return child.level === 1 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function(isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function() {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function() {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function(item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates(account) {
                    return $state.get()
                        .filter(function(s) {
                            var hasRoles = false;
                            if (account === null) { //L'utilisateur n'est pas connecté !
                                hasRoles = (
                                  s.data === undefined ||
                                  s.data.authorities === undefined ||
                                  s.data.authorities.length === 0);
                            } else {//L'utilisateur est connecté, on vérifie ses droits
                                hasRoles = (s.data === undefined || s.data.authorities === undefined ||
                                    s.data.authorities.length === 0 ||
                                    s.data.authorities.filter(function(val) {
                                        return account.authorities !== undefined && account.authorities.indexOf(val) >= 0;
                                    }).length>0);
                            }

                            return s.sidebarMeta && hasRoles;
                        })
                        .map(function(s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name
                            };
                        })
                        .sort(function(a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        }];
        this.$get.$inject = ["$state", "layoutSizes"];

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  baSidebar.$inject = ["$timeout", "baSidebarService", "baUtil", "layoutSizes"];
  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  baPanelSelf.$inject = ["baPanel"];
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  baPanelBlurHelper.$inject = ["$q"];
  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  baPanelBlur.$inject = ["baPanelBlurHelper", "$window", "$rootScope"];
  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  baPanel.$inject = ["baPanel", "baConfig"];
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function() {
    'use strict';

    angular
        .module('josdaviApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'BlurAdmin',
            'restangular',
            'ui-notification',
            'smoothScroll',
            'angular-loading-bar',
            'ds.objectDiff',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
        ])
        .constant('_', window._) // Ajout de la librairie lodash
        .run(run);

    run.$inject = ['$rootScope', 'stateHandler', 'translationHandler', 'Notification'];

    function run($rootScope, stateHandler, translationHandler, Notification) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.$on('josdaviApp.httpError', function(event, err) {
            if (err && err.data) {
                if (err.status === 500) {
                    Notification.error({
                        delay:10000,
                        replaceMessage: true,
                        title: "Erreur",
                        message: "Nous avons rencontré une erreur interne, si cela persiste et vous empêche de travailler, veuillez contacter l'équipe technique."
                    });
                } else if(err.status === 401) {
                    Notification.error({
                        delay:10000,
                        replaceMessage: true,                        
                        title: "Erreur",
                        message: "Vous n'avez pas accès à ces ressources"
                    });
                }else {
                    Notification.error({
                        delay:10000,
                        replaceMessage: true,                        
                        title: "Erreur",
                        message: err.data.message
                    });
                }
            }
        });
        // use in views, ng-repeat="x in _.range(3)"
        $rootScope._ = window._;
    }
})();
(function(){
	"use strict";
	angular.module("josdaviApp").run(appRun);
	appRun.$inject=["$rootScope", "JValidator"];

	function appRun($rootScope, JValidator) {
		$rootScope.$jValidator = JValidator;
	}

})();
(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Principal', Principal);
    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                /*Désactivation temporaire du trackerService*/
                //JhiTrackerService.connect();
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function () {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('josdaviApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$rootScope', '$http', '$localStorage', 'Base64'];

    function AuthServerProvider($rootScope, $http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken;
        }

        function login(credentials) {
            var data = 'username=' + encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=76db325a111fa4e60985bf96fec85d6de&client_id=sms-api-web';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('sms-api-web' + ':' + '76db325a111fa4e60985bf96fec85d6de')
                }
            }).success(authSucess);

            function authSucess(response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                $rootScope.$broadcast('onLoginSuccess');
                return response;
            }
        }

        function logout() {
            $http.post('api/logout').then(function () {
                delete $localStorage.authenticationToken;
                $rootScope.$broadcast('onLogoutSuccess');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    "use strict";
    /**
     * Regroupe l'ensemble des services basés sur Restangular
     * et permettant de manipuler plus aiséments des entités.
     */
    angular.module('josdaviApp')
        .factory('Etablissements',['Restangular', function(Restangular) {
            return Restangular.service('etablissements');
        }]).factory('Inscriptions',['Restangular', function(Restangular) {
            return Restangular.service('inscriptions');
        }]);
})();
(function () {
    var log = console.log;
    var err = console.error;
    var warn = console.warn;
    console.log = function (msg) {
        //On désactive tous les log
        //log.apply(console, arguments);
    };

    console.warn = function (msg) {
        //On désactive tous les log
        //warn.apply(console, arguments);
    };

    console.err = function (msg) {
        //On désactive tous les log
        //err.apply(console, arguments);
    };

})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            title: 'Accueil',
            sidebarMeta: {
                icon: 'fa fa-home',
                order: 0
            },            
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$http', 'baConfig', '$scope', 'Principal', 'LoginService', '$state'];

    function HomeController($http, baConfig, $scope, Principal, LoginService, $state) {
        var vm = this;
        var layoutColors = baConfig.colors;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.showLoginDialog = showLoginDialog;
        vm.loadDatas = loadDatas;
        /**
         * Contient la liste des établissements et leurs effectif associé
         * @type {Array}
         */
        vm.effectifs = [];
        vm.options = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        vm.datasEPE = [];
        vm.datasCPE = [];
        vm.datasIPT = [];
        vm.datasIPA = [];
        vm.datasIPE = [];

        vm.labelsEPE = [];
        vm.labelsCPE = [];
        vm.labelsIPT = [];
        vm.labelsIPA = [];
        vm.labelsIPE = [];

        vm.seriesIPA = [];
        vm.seriesIPE = [];
        vm.estUtilisateurSimple = true;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });
        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                if (account !== null && account !== undefined) {
                    vm.estUtilisateurSimple = account.authorities.indexOf('ROLE_ASSISTANT') !== -1 || account.authorities.indexOf('ROLE_RESPONSABLE_ETABLISSEMENT') !== -1;
                    vm.isAuthenticated = Principal.isAuthenticated;
                    vm.loadDatas();
                }
                vm.showLoginDialog();
            });
        }


        function showLoginDialog() {
            if (!Principal.isAuthenticated()) {
                vm.login();
            }
        }

        function loadDatas() {
            $http.get("api/reporting/stats?type=cpe").then(
                function (res) {
                    vm.datasCPE = res.data.data;
                    vm.labelsCPE = res.data.names;
                });
            $http.get("api/reporting/stats?type=ipt").then(
                function (res) {
                    vm.datasIPT = res.data.data;
                    vm.labelsIPT = res.data.names;
                });
            $http.get("api/reporting/stats?type=ipa").then(
                function (res) {
                    vm.datasIPA = res.data.datas;
                    vm.labelsIPA = res.data.names;
                    vm.seriesIPA = res.data.series;
                });
            $http.get("api/reporting/stats?type=ipe").then(
                function (res) {
                    vm.datasIPE = res.data.datas;
                    vm.labelsIPE = res.data.names;
                    vm.seriesIPE = res.data.series;
                });
            $http.get("api/reporting/effectifs?page=0&size=200&sort=nom,asc").then(
                function (res) {
                    vm.effectifs = res.data;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('ParametreDialogController', ParametreDialogController);

    ParametreDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Parametre'];

    function ParametreDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Parametre) {
        var vm = this;

        vm.parametre = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element("input[type='text']:eq(0)").focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.parametre.id !== null) {
                Parametre.update(vm.parametre, onSaveSuccess, onSaveError);
            } else {
                Parametre.save(vm.parametre, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('josdaviApp:parametreUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('ParametreDeleteController',ParametreDeleteController);

    ParametreDeleteController.$inject = ['$uibModalInstance', 'entity', 'Parametre'];

    function ParametreDeleteController($uibModalInstance, entity, Parametre) {
        var vm = this;

        vm.parametre = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Parametre.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('config', {
            parent: 'entity',
            url: '/parametres',
            title: 'Paramètres',
            sidebarMeta: {
                icon: 'fa fa-cogs',
                order: 15
            },
            data: {
                authorities: ['ROLE_ADMIN','ROLE_RESPONSABLE'],
                pageTitle: 'josdaviApp.parametre.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/parametre/parametres.html',
                    controller: 'ParametreController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });    }

})();

(function() {
    'use strict';
    angular
        .module('josdaviApp')
        .factory('Parametre', Parametre);

    Parametre.$inject = ['$resource'];

    function Parametre ($resource) {
        var resourceUrl =  'api/parametres/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('ParametreController', ParametreController);

    ParametreController.$inject = ['$scope', '$state', 'Parametre', 'TableService'];

    function ParametreController($scope, $state, Parametre, TableService) {

        var vm = this;
        var addItemData = {
            templateUrl: 'app/entities/parametre/parametre-dialog.html',
            controller: 'ParametreDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: function() {
                    return {
                        valeur:null,
                        type:'SYSTEM',
                        nom: null,
                        id: null
                    };
                }
            }
        };



        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/parametre/parametre-dialog.html',
            controller: 'ParametreDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/parametre/parametre-delete-dialog.html',
            controller: 'ParametreDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Parametre,
            entitySearch: Parametre,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('message-recus', {
                parent: 'entity',
                url: '/messages',
                title: "Messages",
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-comment',
                    order: 11
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_ETABLISSEMENT', 'ROLE_ADMIN', 'ROLE_RESPONSABLE', 'ROLE_ASSISTANT', 'ROLE_RESPONSABLE_ASSISTANT', 'ROLE_RESPONSABLE_INSCRIPTION'],
                    pageTitle: 'josdaviApp.activiteAssistant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message/messages.html',
                        controller: 'MessageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('activiteAssistant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('josdaviApp')
        .factory('Message', Message);
    Message.$inject = ['$resource', 'DateUtils'];

    function Message($resource, DateUtils) {
        var resourceUrl = 'api/messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('MessageController', MessageController);

    MessageController.$inject = ['GLOBAL_CONSTANTS', 'Restangular', 'Principal', '$scope', '$state', 'Message', 'TableService'];

    function MessageController(GLOBAL_CONSTANTS, Restangular, Principal, $scope, $state, Message, TableService) {

        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.predicate = 'id';
        vm.date = null;
        vm.contenu = null;
        vm.telephone = null;


        $scope.$watch("vm.contenu", function (d) {
            vm.loadAll();
        });

        $scope.$watch("vm.telephone", function (d) {
            vm.loadAll();
        });

        $scope.$watch("vm.date", function (d) {
            vm.loadAll();
        });


        var dialogData = {
            addData: {},
            editData: {},
            deleteData: {}
        };


        var entitySearchParams = function () {
            return {};
        };
        var entityParams = function () {
            return {
                date: vm.date,
                telephone: vm.telephone,
                contenu: vm.contenu
            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Message,
            entitySearch: Message,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);

    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('info-admin', {
                parent: 'entity',
                url: '/infos-administration',
                title:'Envoyer',
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-tower',
                    order: 9
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_INSCRIPTION', 'ROLE_RESPONSABLE', 'ROLE_ADMIN'],
                    pageTitle: 'josdaviApp.classe.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/info-administrative/info-admin.html',
                        controller: 'InfoAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('InfoAdminController', InfosAdminController);

    InfosAdminController.$inject = ['GLOBAL_CONSTANTS', "$window", 'DataUtils', '$http', '$scope', 'Notification'];

    function InfosAdminController(GLOBAL_CONSTANTS, $window, DataUtils, $http, $scope, Notification) {
        var vm = this;
        vm.isSaving = false;
        vm.datePickerOpenStatus = {};
        vm.dateFormat = GLOBAL_CONSTANTS.DATE_FORMAT;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.dateDebut = false;
        vm.datePickerOpenStatus.dateFin = false;
        vm.reseaux = GLOBAL_CONSTANTS.RESEAUX;

        vm.send = send;
        vm.clear = clear;
        vm.hasError = hasError;
        vm.setFichier = setFichier;

        vm.infos = {
            "contacts": null,
            "contenu": null,
            "sender": null
        };


        function hasError(form, field) {
            return (form.$submitted || field.$touched) && field.$invalid;
        }

        function send() {
            vm.isSaving = true;
            $http.post("api/infos-administration", angular.copy(vm.infos)).then(function () {
                Notification.success("Les informations ont été envoyées avec succès");
                vm.isSaving = false;
                vm.clear();
            }, function () {
                Notification.error("L'envoie du message a échoué");
                vm.isSaving = false;
            });
        }

        function clear() {
            vm.infos = {
                "contacts": null,
                "sender": null,
                "contenu": null
            };
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function setFichier($file, infos) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        infos.fichier = base64Data;
                        infos.fichierContentType = $file.type;
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function () {
    "use strict";
    angular.module('josdaviApp').service('TableService', ['$uibModal', '_', 'ParseLinks', 'Notification', 'GLOBAL_CONSTANTS', service]);

    function service($uibModal, _, ParseLinks, Notification, GLOBAL_CONSTANTS) {
        var self = this;
        self.init = init;
        self.initSimpleTable = initSimpleTable;
        self.initParentInDropdown = initParentInDropdown;


        function init(data) {
            var tableScope = data.scope,
                vm = data.vm,
                Entity = data.entity,
                EntitySearch = data.entitySearch,
                dialogData = data.dialogData,
                entityParams = data.entityParams,
                entitySearchParams = data.entitySearchParams;
            vm.predicate = vm.predicate || 'id';
            /*True = ASC et False = DESC*/
            vm.reverse = false;
            // vm.itemsPerPage = paginationConstants.itemsPerPage;
            vm.itemsPerPage = GLOBAL_CONSTANTS.DEFAULT_ITEMS_PER_PAGE;
            vm.clear = clear;
            vm.search = search;
            vm.loadAll = loadAll;
            vm.setItemsPerPage = setItemsPerPage;
            vm.sortBy = sortBy;
            vm.isCurrentColumn = isCurrentColumn;
            /*Page courante*/
            vm.page = 1;
            /*Nombre d'élements*/
            vm.totalItems = null;
            vm.searchQuery = null;
            vm.currentSearch = null;

            /*Méthode d'ajout, de suppression et de modification*/
            vm.editItem = editItem;
            vm.addItem = addItem;
            vm.deleteItem = deleteItem;
            vm.detailItem = detailItem;
            /*Fonction permettant de n'afficher la pagination que si besoin*/
            vm.canShowPagination = canShowPagination;
            /*Id de la ligne courante sélectionnée*/
            vm.idSelectedCode = null;

            vm.datas = [];

            vm.forward = function (idCode) {
                /*Initialisation du code selectionné*/
                vm.idSelectedCode = idCode;
                console.log("***forward : id =>" + idCode);
                console.log("***vm.totalItems =>" + vm.totalItems);
                /*Scroll automatique jusqu'au details*/
                //smoothScroll.scrollTo('mf-details');
            };

            function canShowPagination() {
                return vm.totalItems > 0 && (vm.totalItems > vm.itemsPerPage);
            }

            /*Observe le changement de la valeur du numéro de page*/
            tableScope.$watch(angular.bind(vm, function () {
                return vm.page;
            }), function (newPage) {
                if (!waitForParent()) {
                    loadAll();
                }
            });

            function setItemsPerPage(value) {
                vm.itemsPerPage = value;
                changePageAndLoadAll();
            }

            /**
             *Utilisée au cas où les éléments de l'entité sont listés en fonction de l'id du parent.
             *Dans ce cas, on verifie que l'entité est bien associée à un parent et que ce parent
             *est à l'instant T connu.
             */
            function waitForParent() {
                /*var b  = false ;*/
                if (angular.isFunction(vm.getParentId)) {
                    var id = vm.getParentId();
                    if (angular.isUndefined(id) || id === null) {
                        return true;
                    }
                    console.log("***waitForParent : " + vm.getParentId());
                }

                return false;
            }

            function changePageAndLoadAll() {
                if (vm.page == 1) {
                    loadAll();
                } else {
                    /*Le changement de la page rechargement directement les données du à un watcher sur cet attribut*/
                    vm.page = 1;
                }
            }

            function loadAll() {
                console.log("***Loading items");
                if (vm.currentSearch !== null) {
                    var d = _.merge({
                        /*Paramètres initials*/
                        query: vm.currentSearch,
                        page: vm.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, entitySearchParams());
                    EntitySearch.query(d, onSuccess, onError);
                } else {
                    var d = _.merge({
                        page: vm.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, entityParams());
                    Entity.query(d, onSuccess, onError);
                }

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    /**
                     *Cette condition est testée pour pouvoir prendre en compte le faite que
                     *toutes les tables ne prennent pas en compte la pagination.
                     */
                    if (headers('link') !== null && headers('link') !== undefined) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                    } else {
                        vm.queryCount = data.length;
                    }
                    vm.datas = data;
                }

                function onError(error) {
                    Notification.error(error.data.message);
                }
            }

            function search(searchQuery) {
                if (!searchQuery) {
                    return vm.clear();
                }
                vm.links = null;
                vm.predicate = 'id';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
                vm.idSelectedCode = null;
                changePageAndLoadAll();
            }

            function clear() {
                vm.links = null;
                vm.predicate = 'id';
                vm.reverse = true;
                vm.currentSearch = null;
                vm.searchQuery = null;
                vm.idSelectedCode = null;
                changePageAndLoadAll();
            }

            /*##############################################################################*/

            /*##########################Gestion du trie par colonne#########################*/
            function sortBy(column) {
                if (column === vm.predicate) { //S'il s'agit de la même column, on inverse l'ordre du trie
                    reverse();
                } else { // Sinon, on remet l'ordre à ascendant ou croissant
                    vm.reverse = true;
                }
                vm.predicate = column;
                loadAll();
            }

            /*Inverse l'ordre de trie*/
            function reverse() {
                vm.reverse = !vm.reverse;
            }

            function isCurrentColumn(column) {
                return vm.predicate === column;
            }

            /**
             *Ajout d'un élément
             */
            function addItem() {
                $uibModal.open(dialogData.addData).result.then(function (result) {
                    Notification.success('Enregistrement reussit !');
                    /*Ajout de l'élément ajouté dans le tableau, en le triant avec les paramètres courants*/
                    if (vm.datas !== null) {
                        vm.totalItems = vm.totalItems + 1;
                        if (vm.itemsPerPage > vm.totalItems) {
                            vm.datas.push(result);
                            vm.datas = _.sortBy(vm.datas, vm.predicate, !vm.reverse);
                            loadAll();
                        } else {
                            loadAll();
                        }

                    } else {
                        console.error("***vm.datas is null");
                    }
                }, function () {
                });
            }

            function detailItem($event, item) {
                $event.stopPropagation();
                dialogData.detailData.resolve.entity = angular.copy(item);
                console.log("***detailItem for " + item.id);
                $uibModal.open(dialogData.detailData).result.then(function (datas) {

                    if (datas.isEdit) {
                        angular.forEach(item, function (value, key) {
                            item[key] = datas.result[key];
                        });
                        Notification.success('Modification reussit !');

                    }

                }, function () {

                    console.info("***Closing detail dialog");
                });
            }

            /**
             *Modification d'un élément
             */
            function editItem($event, item) {
                $event.stopPropagation();
                dialogData.editData.resolve.entity = angular.copy(item);
                $uibModal.open(dialogData.editData).result.then(function (result) {
                    Notification.success('Modification reussit !');
                    /*Les valeurs dans result écrase celle d'item */
                    angular.forEach(item, function (value, key) {
                        item[key] = result[key];
                    });
                    loadAll();
                }, function () {

                });
            }

            /**
             *Suppression d'un élément
             **/
            function deleteItem($event, item) {
                $event.stopPropagation();
                dialogData.deleteData.resolve.entity = item;
                $uibModal.open(dialogData.deleteData).result.then(function (result) {
                    loadAll();
                    Notification.success('Suppression effectué !');
                }, function () {

                });
            }

            return vm;
        }

        function initParentInDropdown(data) {
            var vm = data.vm,
                scope = data.scope,
                ParentEntity = data.ParentEntity,
                filter = data.filter,
                orderBy = data.orderBy,
                dialogData = data.dialogData;

            vm.parents = loadParents();
            vm.addParent = addParent;
            vm.editParent = editParent;
            vm.deleteParent = deleteParent;
            vm.getParentId = getParentId;
            vm.currentParent = {};
            vm.setCurrentParent = setCurrentParent;
            vm.hasParents = hasParents;

            /*Observe le changement de la catégorie*/
            scope.$watch(angular.bind(vm, function () {
                if (angular.isDefined(vm.currentParent)) {
                    return vm.currentParent.id;
                }
            }), function (newValue) {
                //console.log('***New value for currentParent id = ' + newValue);
                if (angular.isDefined(newValue)) {
                    //Obtention de l'objet à partir de son id
                    var item = _.find(vm.parents, function (p) {
                        p.id === newValue;
                    });
                    vm.setCurrentParent(item, false);
                    /*Chargement des critères si la catégorie sélectionnée change!*/
                    if (angular.isFunction(vm.loadAll)) {
                        vm.loadAll();
                    }
                }
            });

            function hasParents() {
                if (angular.isDefined(vm.parents)) {
                    return vm.parents.length > 0;
                }
                return false;
            }

            function getParentId() {
                if (angular.isDefined(vm.currentParent)) {
                    return vm.currentParent.id;
                } else {
                    console.error("***Parent not selected.");
                    return null;
                }
            }

            function setCurrentParent(item, eraseId) {
                console.log('***Changing current parent.With eraseId = ' + eraseId);
                angular.forEach(item, function (value, key) {
                    if (eraseId || key != "id") {
                        //console.log("***Copy of key = " + key);
                        //console.log("***Old value = " + vm.currentParent[key]);
                        vm.currentParent[key] = item[key];
                        //console.log("***New value = " + vm.currentParent[key]);
                    }
                });
            }

            function loadParents() {
                //console.log("***Loading all parents");
                return ParentEntity.query(function () {
                    if (angular.isDefined(vm.parents) && vm.parents.length > 0) {
                        vm.parents = filter('orderBy')(vm.parents, orderBy);
                        vm.setCurrentParent(vm.parents[0], true);
                    }
                }, function () {
                    console.error("Impossible de charger la liste des parents.");
                });
            }

            function addParent() {
                console.log('***Add a parent');
                $uibModal.open(dialogData.addParent).result.then(function (result) {
                    if (vm.parents !== null) {
                        vm.parents.push(result);
                        vm.parents = filter('orderBy')(vm.parents, orderBy);
                        vm.setCurrentParent(vm.parents[0], true);
                    } else {
                        console.log("***vm.parents is NULL");
                    }
                }, function () {
                });
            }

            function editParent() {
                console.log('***Editing parent with id : ' + vm.currentParent.id);
                //var editedItem = angular.copy(vm.currentParent, {});
                dialogData.editParent.resolve.entity = angular.copy(vm.currentParent);
                //console.log(editedItem);

                $uibModal.open(dialogData.editParent).result.then(function (item) {
                    vm.parents = _.reject(vm.parents, ['id', item.id]);
                    vm.parents.push(item);
                    vm.parents = filter('orderBy')(vm.parents, orderBy);
                    vm.setCurrentParent(item, false);
                });
            }

            function deleteParent() {
                console.log('***Delete parent with id : ' + vm.currentParent.id);
                dialogData.deleteParent.resolve.entity = vm.currentParent;
                $uibModal.open(dialogData.deleteParent).result.then(function () {
                    console.log('***Item deleted.');
                    vm.parents = _.reject(vm.parents, ['id', vm.currentParent.id]);
                    vm.parents = filter('orderBy')(vm.parents, orderBy);
                    vm.setCurrentParent(vm.parents[0], true);
                });
            }

            return vm;
        }

        /**Initialise les tableaux simples qui n'ont ni de pagination,ni de trie, ni de barre de recherche.
         *Uniquement l'affichage, la modification et la suppression d'un élément.
         */
        function initSimpleTable(data) {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    "use strict";
    angular.module("josdaviApp").directive('jRequired', [function() {
        return {
            restrict: 'A',
            link: function(scope, iElement, iAttrs) {
                angular.element(iElement).ready(function() {
                    iElement.append("<span class='text-danger'><b> *</b></span>");
                    iElement.addClass("pr2");
                });
            }
        };
    }]);
})();
(function(){
    'use strict';

    angular
        .module('josdaviApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('josdaviApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function () {
    "use strict";
    angular.module("josdaviApp")
        .constant('GLOBAL_CONSTANTS', {
            'DATE_FORMAT': 'dd/MM/yyyy',
            'DATE_FORMAT_FR': 'jj/mm/an',
            'DATETIME_FORMAT': 'dd/MM/yyyy à HH:MM',
            'DEFAULT_ITEMS_PER_PAGE': 15,
            'MAX_ITEMS_PER_PAGE': 10000000,
            'RESEAUX': ['TELMOB', 'ORANGE', 'TELECEL', 'AUTRES', 'TOUS']
        });
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('josdaviApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    "use strict";
    angular.module('josdaviApp').directive('jSelectDialog', select);
    select.$inject = ['$uibModal', "$rootScope"];

    function select($uibModal, $rootScope) {
        var modalInstance;
        return {
            restrict: 'AE',
            scope: {
                datas: '=jList',
                model: '=jModel',
                multiple: '=jMultiple',
                columns: '=jColumns',
                eventName: '@jEventName',
                onFilter: '&jOnSearch'
            },
            link: function(scope, iElement, iAttrs, iCtrl) {
                var d = {
                    templateUrl: 'app/components/select/select-dialog.html',
                    controller: function() {
                        var ctrl = this;
                        ctrl.query = "";
                        ctrl.cancel = cancel;
                        ctrl.confirm = confirm;
                        ctrl.isChecked = isChecked;
                        ctrl.toggle = toggle;
                        ctrl.datas = scope.datas;
                        ctrl.columns = scope.columns;
                        ctrl.onFilter = scope.onFilter;
                        ctrl.check = check;
                        ctrl.uncheck = uncheck;
                        ctrl.multiple = scope.multiple;
                        ctrl.toggleAll = toggleAll;
                        ctrl.getColumnTitle = getColumnTitle;
                        ctrl.getColumnName = getColumnName;

                        scope.$watch(angular.bind(scope, function() {
                            return scope.datas;
                        }), function(items) {
                            ctrl.datas = items;
                        });

                        /**A SUIVRE : L'appel de la fonction ctrl.onFilter ne fonctionne pas ! Le
                         * newValue passé est toujours vide !
                         */
                        scope.$watch(angular.bind(ctrl, function() {
                            return ctrl.query;
                        }), function(newValue) {
                            scope.filterText = newValue;
                        });

                        ctrl.model = angular.copy(scope.model);
                        if (angular.isUndefined(ctrl.model)) {
                            if (ctrl.multiple) {
                                ctrl.model = [];
                            } else {
                                ctrl.model = '';
                            }
                        }

                        function getColumnTitle(column) {
                            if (angular.isDefined(column) && column !== null) {
                                if (column.indexOf(',') !== -1) {
                                    var items = column.split(',');
                                    if (items.length !== 2) {
                                        console.error("***Column " + column + " is incorrect");
                                    }
                                    return items[1].trim();
                                } else {
                                    return column.trim();
                                }
                            }
                            return "";
                        }

                        function getColumnName(column) {
                            if (angular.isDefined(column) && column !== null) {
                                if (column.indexOf(',') !== -1) {
                                    var items = column.split(',');
                                    if (items.length !== 2) {
                                        console.error("***Column " + column + " is incorrect");
                                    }
                                    return items[0];
                                } else {
                                    return column;
                                }
                            } else {
                                console.error("***Column name can't be null");
                                return "";
                            }
                        }

                        function cancel() {
                            modalInstance.dismiss('cancel');
                        }

                        function confirm() {
                            modalInstance.close(ctrl.model);
                        }

                        function isChecked(item) {
                            if (ctrl.multiple) {
                                return Lazy(ctrl.model).contains(item.id);
                            } else {
                                return ctrl.model === item.id;
                            }
                        }

                        function toggle(item) {
                            if (ctrl.isChecked(item)) {
                                ctrl.uncheck(item);
                            } else {
                                ctrl.check(item);
                            }
                        }

                        function toggleAll() {
                            if (ctrl.allSelected) {
                                angular.forEach(ctrl.datas, function(val, key) {
                                    ctrl.check(val);
                                });
                            } else {
                                angular.forEach(ctrl.datas, function(val, key) {
                                    ctrl.uncheck(val);
                                });
                            }
                        }

                        function check(item) {
                            if (ctrl.multiple) {
                                ctrl.model.push(item.id);
                            } else {
                                ctrl.model = item.id;
                            }
                        }

                        function uncheck(item) {
                            if (ctrl.multiple) {
                                ctrl.model = _.reject(ctrl.model, ['id', item.id]);
                            } else {
                                ctrl.model = '';
                            }
                        }
                    },
                    controllerAs: 'ctrl',
                    size: 'md',
                    backdrop: 'static'
                };

                iElement.on("click", function(event) {
                    if (angular.isDefined(scope.eventName)) {
                        $rootScope.$broadcast(scope.eventName);
                    }
                    modalInstance = $uibModal.open(d);
                    modalInstance.result.then(
                        function(res) {
                            scope.model = res;
                        },
                        function() {

                        });
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'fr': { name: 'Français' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'fr'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);
/*!
 * See LICENSE in this repository for license information
 */
(function(){
'use strict';
var xtForm = angular.module('josdaviApp');
xtForm.directive('ngModel', ["xtFormConfig", "$rootScope", "$interpolate", "$document", function (xtFormConfig, $rootScope, $interpolate, $document) {
    'use strict';

    var UNTOUCHED_CLASS = 'ng-untouched',
        TOUCHED_CLASS = 'ng-touched';

    return {
        require: ['ngModel', '^?xtForm', '^?form'],
        link: function (scope, element, attrs, ctrls) {

            var defaultErrors = xtFormConfig.getErrorMessages(),
                ngModel = ctrls[0],
                xtForm = ctrls[1],
                form = ctrls[2],
                setTouchedFn,
                validationStrategyFn;

            /**
             * Active the directive
             */
            function activate() {

                setTouchedFn = ngModel.$setTouched || setTouchedPolyfill;
                validationStrategyFn = xtForm.getValidationStrategy();
                ngModel.$untouched = true;

                // add extensions to ngModel
                var labelEl = $document[0].querySelectorAll('label[for="' + attrs.id + '"]');
                angular.extend(ngModel, {
                    $focused: false,
                    $label: labelEl.length > 0 ? labelEl[0].innerText : '',
                    $xtErrors: []
                });

                // set errors on the ngModel when $error changes
                scope.$watch(function () {
                    return ngModel.$error;
                }, updateErrors, true);

                scope.$on('XtForm.ForceErrorUpdate', updateErrors);

                element
                    .on('focus', function () {
                        if (!ngModel.$touched) {
                            setTouchedFn();
                        }
                        ngModel.$focused = true;
                        updateErrors();
                        scope.$apply();
                    })
                    .on('blur', function () {
                        ngModel.$focused = false;
                        updateErrors();
                        scope.$apply();
                    });
            }

            function getErrorMessageForKey(key) {
                var attrKey = 'msg' + key[0].toUpperCase() + key.substring(1);

                // use either the provided string as an interpolated attribute, or the default message
                return attrs[attrKey] ?
                    attrs[attrKey] :
                    $interpolate(defaultErrors[key])(attrs);
            }

            /**
             * Sets the $xtErrors collection on validation change
             */
            function updateErrors() {
                ngModel.$xtErrors = [];

                angular.forEach(ngModel.$error, function (value, key) {
                    var showErrors = value && validationStrategyFn(form, ngModel);
                    if (showErrors) {
                        var error = {
                            key: key,
                            message: getErrorMessageForKey(key)
                        };

                        // This is a bit of hack right now to ensure that data type validation errors are shown
                        // in priority over the required message if both fail.
                        // TODO will likely need to introduce priorities of error messages
                        if (key === 'required') {
                            ngModel.$xtErrors.push(error);
                        } else {
                            ngModel.$xtErrors.unshift(error);
                        }
                    }


                });

                $rootScope.$broadcast('XtForm.ErrorsUpdated', ngModel);
            }

            // Polyfill for $touched in AngularJS < 1.3
            function setTouchedPolyfill() {
                ngModel.$touched = true;
                ngModel.$untouched = false;
                element.addClass(TOUCHED_CLASS).removeClass(UNTOUCHED_CLASS);
            }

            if (xtForm) {
                activate();
            }
        }
    };
}]);
xtForm
    .directive('xtForm', ["$timeout", function ($timeout) {
        'use strict';

        return {
            require: '',
            priority: -1,
            controller: 'XtFormController',
            controllerAs: 'xtForm',
            link: function (scope, element, attrs, xtForm) {
                element
                    .on('submit', function () {
                        scope.$apply(function () {
                            xtForm.submit();
                        });
                    })
                    .on('reset', function () {
                        $timeout(function () {
                            xtForm.reset();
                        });
                    });
            }
        };
    }])
    .controller('XtFormController', ["$scope", "$element", "$attrs", "xtFormConfig", "$window", function ($scope, $element, $attrs, xtFormConfig, $window) {
        'use strict';

        var vm = this,
            form = $element.controller('form'),
            validationStrategy = $attrs.strategy ?
                xtFormConfig.getValidationStrategy($attrs.strategy) :
                xtFormConfig.getDefaultValidationStrategy();

        //polyfill for setSubmitted pre 1.3
        function setSubmitted() {
            if (angular.isFunction(form.$setSubmitted)) {
                form.$setSubmitted();
                return;
            }
            form.$submitted = true;
            $element.addClass('ng-submitted');
        }

        function setUnsubmitted() {
            if (angular.isFunction(form.$setSubmitted)) {
                return;
            }
            form.$submitted = false;
            $element.removeClass('ng-submitted');
        }

        angular.extend(vm, {

            form: form,

            getValidationStrategy: function () {
                return validationStrategy;
            },

            tooltipTrigger: $attrs.tooltipTrigger,

            submit: function () {
                setSubmitted();

                // focus first error if required
                if (form.$invalid && $attrs.focusError) {
                    $window.setTimeout(function () {
                        $element.find('.ng-invalid:input:visible:first').focus();
                    });
                }

                $scope.$broadcast('XtForm.ForceErrorUpdate', null, 'submit');
            },

            reset: function () {
                vm.form.$setPristine();
                vm.form.$setUntouched();
                setUnsubmitted();

                $scope.$broadcast('XtForm.ForceErrorUpdate', null, 'reset');
            }

        });
    }]);
xtForm.provider('xtFormConfig', function () {
    'use strict';

    var self = this,
        _errors = {
            minlength: 'Doit avoir plus de {{ngMinlength}} caractères',
            maxlength: 'Doit avoir moins de {{ngMaxlength}} caractères',
            required: 'Ce champ est obligatoire',
            number: 'Doit-être un nombre',
            min: 'Doit-être supérieur à {{min}}',
            max: 'Doit-être inférieur à {{max}}',
            email: 'Doit-être un mail valide',
            pattern: 'Format invalide',
            url: 'Doit-être un URL valide',
            date: 'Doit-être une date valide',
            datetimelocal: 'Doit-être une date valide',
            time: 'Doit-être une heure valide',
            week: 'Doit-être un jour de semaine valide',
            month: 'Doit-être un mois valide',
            $$server: 'Une erreur est survenue'
        },
        _validationStrategyFn;

    angular.extend(self, {

        $validationStrategies: {
            invalid: function (form) {
                return form.$invalid;
            },
            submitted: function (form) {
                return form.$invalid && form.$submitted;
            },
            dirty: function (form, ngModel) {
                return ngModel.$invalid && ngModel.$dirty;
            },
            dirtyOrSubmitted: function (form, ngModel) {
                return ngModel.$invalid && (form.$submitted || ngModel.$dirty);
            },
            focusedAndDirtyOrSubmitted: function (form, ngModel) {
                return ngModel.$invalid && (ngModel.$focused && (ngModel.$dirty || form.$submitted));
            },
            dirtyAndFocusedOrSubmitted: function (form, ngModel) {
                return ngModel.$invalid && (form.$submitted || (ngModel.$dirty && ngModel.$focused));
            }
        },

        addValidationStrategy: function (name, fn) {
            self.$validationStrategies[name] = fn;
        },

        setDefaultValidationStrategy: function (strategy) {
            if (!self.$validationStrategies[strategy]) {
                throw new Error('Could not find validation strategy by name: ' + strategy);
            }
            _validationStrategyFn = self.$validationStrategies[strategy];
        },

        setErrorMessages: function (errors) {
            angular.extend(_errors, errors);
        }

    });

    this.$get = function () {
        return {
            getErrorMessages: function () {
                return angular.copy(_errors);
            },
            getValidationStrategy: function (name) {
                if (!self.$validationStrategies[name]) {
                    throw new Error('Could not find validation strategy by name: ' + name);
                }
                return self.$validationStrategies[name];
            },
            getDefaultValidationStrategy: function () {
                return _validationStrategyFn;
            }
        };
    };

    self.setDefaultValidationStrategy('dirtyOrSubmitted');
});
xtForm.directive('xtValidationInline', ["$templateCache", function ($templateCache) {
    'use strict';

    var _uniqueIdCounter = 0;

    function nextUniqueId() {
        return 'validation_' + _uniqueIdCounter++;
    }

    return {
        require: ['^xtForm'],
        restrict: 'EA',
        scope: true,
        replace: true,
        template: function (element, attrs) {
            return $templateCache.get(attrs.templateUrl || 'xtForm/inline/validationInline.html');
        },
        link: function (scope, element, attrs) {

            var inputId = attrs.for || attrs.xtValidationInline;
            if (angular.isUndefined(inputId)) {
                throw new Error('The validation input id must be specified eg. for="id"');
            }

            var inputEl = angular.element(document.getElementById(inputId));
            if (inputEl.length === 0) {
                throw new Error('Can not find input element for the validation directive');
            }

            var ngModel = inputEl.controller('ngModel');

            /**
             * Activates the directive
             */
            function activate() {
                element.addClass('xt-validation-inline');

                // Ensure the validation control has an id
                if (!attrs.id) {
                    attrs.id = nextUniqueId();
                    element.attr('id', attrs.id);
                }

                // Add aria attribute to denote required state
                if (!!inputEl.attr('required')) {
                    inputEl.attr('aria-required', true);
                }

                // Subscribe to "errors updated" event and redraw errors when changed
                scope.$on('XtForm.ErrorsUpdated', function (message, model) {
                    if (model === null || model === ngModel) {
                        redrawErrors();
                    }
                });
            }

            /**
             * Will redraw error spans on the page when required
             */
            function redrawErrors() {
                var noOfErrors = attrs.multiple ? ngModel.$xtErrors.length : 1;
                scope.errors = ngModel.$xtErrors.slice(0, noOfErrors);
                scope.showErrors = scope.errors.length > 0;
                toggleAriaAttributes(scope.showErrors);
            }

            /**
             * Toggle aria attributes to denote validity state
             * @param showErrors true to add error state
             */
            function toggleAriaAttributes(showErrors) {
                if (showErrors) {
                    inputEl
                        .attr('aria-invalid', true)
                        .attr('aria-describedby', attrs.id);
                } else {
                    inputEl.removeAttr('aria-invalid');
                    inputEl.removeAttr('aria-describedby');
                }
            }

            activate();
        }
    };
}]);
xtForm.directive('xtValidationTooltip', ["$timeout", function ($timeout) {
    'use strict';

    return {
        require: '^xtForm',
        restrict: 'EA',
        link: function (scope, element, attrs, xtForm) {

            var ngModelElement,
                ngModel,
                lastErrors;

            /**
             * Activates the directive
             */
            function activate() {

                setupNgModel();
                setupTooltipElement();

                // Subscribe to "errors updated" event and redraw errors when changed
                scope.$on('XtForm.ErrorsUpdated', function (message, model) {
                    if (model === null || model === ngModel) {
                        redrawErrors();
                    }
                });
            }

            function setupTooltipElement() {

                element.addClass('xt-error-container');

                // default SELECT tooltip placement to top
                if (element[0].nodeName.toUpperCase() === 'SELECT' && !attrs.placement) {
                    attrs.placement = 'top';
                    element.attr('placement', attrs.placement);
                }

                element.tooltip({
                    animation: false,
                    html: true,
                    placement: attrs.placement || 'bottom',
                    trigger: xtForm.tooltipTrigger || 'manual',
                    container: attrs.container || 'body'
                });
            }

            function setupNgModel() {

                // allow for a different tooltip container that is not on the ngModel element
                var ngModelElementId = attrs.for || attrs.xtValidationTooltip;
                ngModelElement = ngModelElementId ?
                    angular.element(document.getElementById(ngModelElementId)) :
                    element;

                ngModelElement.addClass('xt-validation-tooltip');

                if (!!ngModelElement.attr('required')) {
                    ngModelElement.attr('aria-required', true);
                }

                // TODO This is a HACK to ensure the ngModel controller is created on the element before usage.
                // FIXME this should be removed and replaced with an alternative method perhaps on the ngModel directive
                // to register with xtform controller
                $timeout(function () {
                    ngModel = ngModelElement.controller('ngModel');
                    if (!ngModel) {
                        throw new Error('Cannot find ngModel element for xtValidationTooltip');
                    }
                });
            }

            function redrawErrors() {

                if (ngModel.$xtErrors.length === 0) {
                    lastErrors = null;
                    element.tooltip('hide');
                    return;
                }

                // hmm reduce adds br to front of string..
                var noOfErrors = attrs.multiple ? ngModel.$xtErrors.length : 1;
                var errors = ngModel.$xtErrors
                    .slice(0, noOfErrors)
                    .map(function (value) {
                        return value.message;
                    })
                    .join('<br />');

                // only redraw if needed
                if (errors !== lastErrors) {
                    lastErrors = errors;

                    setTimeout(function () {
                        element
                            .attr('title', errors)
                            .tooltip('fixTitle')
                            .tooltip('show');
                    });
                }
            }

            if (!$ || !angular.isFunction($.fn.tooltip)) {
                throw new Error('xtform requires a jquery tooltip plugin, like bootstrap.js');
            }

            activate();
        }
    };
}]);
xtForm.directive('xtValidationSummary', ["$templateCache", function ($templateCache) {
    'use strict';

    return {
        require: ['^xtForm', '^form'],
        restrict: 'EA',
        replace: true,
        scope: true,
        template: function (element, attrs) {
            return $templateCache.get(attrs.templateUrl || 'xtForm/summary/validationSummary.html');
        },
        link: function (scope, element, attrs, ctrls) {

            var form = ctrls[1];
            scope.showLabel = (attrs.showLabel === 'true') || angular.isUndefined(attrs.showLabel);

            function redrawErrors() {

                scope.errors = [];
                angular.forEach(form, function (ngModel, ngModelKey) {
                    if (ngModelKey[0] !== '$') {

                        // can show one error for each input, or multiple
                        var noOfErrors = attrs.multiple ? ngModel.$xtErrors.length : 1,
                            errors = ngModel.$xtErrors.slice(0, noOfErrors);

                        angular.forEach(errors, function (value) {
                            scope.errors.push({
                                key: value.key,
                                label: ngModel.$label,
                                message: value.message
                            });
                        });
                    }
                });

                scope.showErrors = scope.errors.length > 0;
            }

            scope.$on('XtForm.ErrorsUpdated', redrawErrors);
        }
    };
}]);
})();
(function() {
    "use strict";
    angular.module('josdaviApp').factory('JValidator', srvc);

    function srvc() {

        function hasError(form, field) {
            return field!==undefined && (form.$submitted || field.$touched) && field.$invalid;
        }

        return {
        	hasError : hasError
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('josdaviApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('josdaviApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('josdaviApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('josdaviApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('josdaviApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('DateConvertInterceptor', DateConvertInterceptor);

    DateConvertInterceptor.$inject = [];

    function DateConvertInterceptor() {
        var service = {
            'responses': convertDate
        };

        //var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;
        var regexIso8601 = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;

        function convertDate(input) {
            console.log("****DateConvertInterceptor  : Converting an item to objet");
            console.log(input);
            // Ignore things that aren't objects.
            if (typeof input !== "object") return input;

            for (var key in input) {
                if (!input.hasOwnProperty(key)) continue;

                var value = input[key];
                var match;
                // Check for string properties which look like dates.
                if (typeof value === "string" && (match = value.match(regexIso8601))) {
                    var milliseconds = Date.parse(match[0])
                    if (!isNaN(milliseconds)) {
                        input[key] = new Date(milliseconds);
                    }
                } else if (typeof value === "object") {
                    // Recurse into object
                    return convertDate(value);
                }
            }
            return input;
        }
        return service;
    }
})();
(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "fr"');
                $cookies.putObject(name, 'fr');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('fr');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push('DateConvertInterceptor');
        /*Convertit automatiquement les dates/datetimes provenant du serveur*/
        //$httpProvider.defaults.transformResponse.push();
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('josdaviApp')
        .constant('VERSION', "1.0.6")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1666127107589)
;
})();

(function() {
    "use strict";
    angular.module("josdaviApp")
        .config(cfg);
    cfg.$inject = ["RestangularProvider"];

    function cfg(RestangularProvider) {
        RestangularProvider.setBaseUrl('/api');
    }
})();
(function () {
        'use strict';

        angular
            .module('josdaviApp')
            .controller('UserManagementDialogController', UserManagementDialogController);

        UserManagementDialogController.$inject = ['copy', 'GLOBAL_CONSTANTS', 'Etablissement', 'Restangular', 'vue', '$scope', '$q', 'DataUtils', '$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

        function UserManagementDialogController(copy, GLOBAL_CONSTANTS, Etablissement, Restangular, vue, $scope, $q, DataUtils, $stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
            var vm = this;

            vm.isVue = function () {
                return vue;
            };
            vm.copy = copy;
            vm.typeActeur = ["Assistant", "Responsable", "Autre"];
            vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_RESPONSABLE_INSCRIPTION', 'ROLE_RESPONSABLE', 'ROLE_RESPONSABLE_ASSISTANT', 'ROLE_RESPONSABLE_ETABLISSEMENT', 'ROLE_ASSISTANT'];
            vm.clear = clear;
            vm.languages = null;
            vm.save = save;
            vm.user = entity;
            vm.user.email = "b@kafyka.com";

            var userAll = {};
            vm.removePicture = removePicture;
            vm.loadEtablissements = loadEtablissements;

            vm.etablissementColumns = [{
                name: 'numero',
                title: 'Numéro'
            }, {
                name: 'nom',
                title: 'Nom'
            }, {
                name: 'type',
                title: 'Type'
            }];

            $scope.$watch("vm.typeActeur", function (typeActeur) {
                if (typeActeur !== undefined && typeActeur !== null) {
                    switch (typeActeur) {
                        case "ASSISTANT":
                            vm.user.authorities = ['ROLE_USER', 'ROLE_ASSISTANT'];
                            break;
                        case "RESPONSABLE":
                            vm.user.authorities = ['ROLE_USER', 'ROLE_RESPONSABLE_ETABLISSEMENT'];
                            break;
                        case "AUTRE":
                            vm.user.authorities = [];
                            break;
                    }
                }
            });


            $scope.$on("onLoadEtablissements", function () {
                vm.loadEtablissements();
            });

            $scope.$watch("vm.user.etablissementId", function (id) {
                if (id !== undefined && id !== null) {
                    vm.etablissement = _.find(vm.etablissements, {
                        'id': id
                    });
                }
            });

            function loadEtablissements() {
                vm.etablissements = Etablissement.query({
                    size: GLOBAL_CONSTANTS.MAX_ITEMS_PER_PAGE,
                    sort: 'nom,asc'
                });
            }


            //Pour une modification effectué par un assistant

            if (angular.isDefined(vm.user.userExtraDTO)) {
                if (vm.user.userExtraDTO.id != null) {
                    userAll = vm.user;
                    vm.user = {};
                    vm.loadEtablissements();
                    if (!vm.copy) {
                        vm.user.id = userAll.userDTO.id;
                        vm.user.email = userAll.userDTO.email;
                        vm.user.login = userAll.userDTO.login;

                    } else {
                        vm.user.id = null;
                        vm.user.password = null;
                        vm.user.login = null;
                    }
                    vm.user.firstName = userAll.userDTO.firstName;
                    vm.user.lastName = userAll.userDTO.lastName;
                    vm.user.activated = userAll.userDTO.activated;
                    vm.user.authorities = userAll.userDTO.authorities;
                    vm.user.code = userAll.userExtraDTO.code;
                    vm.user.telephone = userAll.userExtraDTO.telephone;
                    vm.user.typeCarte = userAll.userExtraDTO.typeCarte;
                    vm.user.numeroCarte = userAll.userExtraDTO.numeroCarte;
                    vm.user.photo = userAll.userExtraDTO.photo;
                    vm.user.photoContentType = userAll.userExtraDTO.photoContentType;
                    vm.user.etablissementId = userAll.userExtraDTO.etablissementId;
                    Restangular.all('etablissements').getList().then(function (etablissements) {
                        vm.etablissements = etablissements;
                        if (vm.user.etablissementId !== undefined && vm.user.etablissementId !== null) {
                            vm.etablissement = _.find(vm.etablissements, {
                                'id': vm.user.etablissementId
                            });
                        }
                    });
                }
            }

            JhiLanguageService.getAll().then(function (languages) {
                vm.languages = languages;
            });

            function clear() {
                $uibModalInstance.dismiss('cancel');
            }

            function onSaveSuccess(result) {
                vm.isSaving = false;
                $uibModalInstance.close(result);
            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function save() {
                vm.isSaving = true;
                vm.user.email = vm.user.login + "@kafyka.com";
                if (angular.isDefined(userAll.userExtraDTO)) {
                    if (userAll.userExtraDTO.id != null) {
                        if (!vm.copy) {
                            userAll.userDTO.login = vm.user.login;
                            userAll.userDTO.firstName = vm.user.firstName;
                            userAll.userDTO.lastName = vm.user.lastName;
                            userAll.userDTO.email = vm.user.email;
                            userAll.userDTO.activated = vm.user.activated;
                            userAll.userDTO.authorities = vm.user.authorities;

                            userAll.userExtraDTO.code = vm.user.code;
                            userAll.userExtraDTO.telephone = vm.user.telephone;
                            userAll.userExtraDTO.typeCarte = vm.user.typeCarte;
                            userAll.userExtraDTO.numeroCarte = vm.user.numeroCarte;
                            userAll.userExtraDTO.photo = vm.user.photo;
                            userAll.userExtraDTO.photoContentType = vm.user.photoContentType;
                            userAll.userExtraDTO.etablissementId = vm.user.etablissementId;
                            User.update(userAll, onSaveSuccess, onSaveError);
                        } else {
                            User.save(vm.user, onSaveSuccess, onSaveError);
                        }
                    }
                } else if (vm.user.id != null) { //Pour un ajout à travers une entite existente
                    userAll.userDTO = vm.user;
                    userAll.userExtraDTO = null;
                    User.update(userAll, onSaveSuccess, onSaveError);
                } else {
                    User.save(vm.user, onSaveSuccess, onSaveError);
                }
            }

            vm.setPhoto = function ($file, userExtra) {
                if ($file && $file.$error === 'pattern') {
                    return;
                }
                if ($file) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            userExtra.photo = base64Data;
                            userExtra.photoContentType = $file.type;
                        });
                    });
                }
            };


            function removePicture() {
                vm.user.photo = null;
                vm.user.photoContentType = null;
                vm.noPicture = false;
            }

        }
    }

)();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.user-management', {
                url: '/user-management?page&sort',
                title: "Gérer les utilisateurs",
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-tower',
                    order: 1
                },
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('userExtra');
                        $translatePartialLoader.addPart('typeCarte');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();
(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Notification', '$http', '$scope', 'Principal', 'User', 'TableService', '$state', 'JhiLanguageService'];

    function UserManagementController(Notification, $http, $scope, Principal, User, TableService, $state, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.setActive = setActive;
        vm.resendActivationItem = resendActivationItem;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        function setActive(user, isActivated) {
            user.activated = isActivated;
            var userAll = {};
            userAll.userDTO = user;
            userAll.userExtraDTO = null;
            User.update(userAll, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function resendActivationItem($event, user) {
            $http.post('api/users/' + user.login + '/activate').then(
                function () {
                    Notification.success("Le mail d'activation a été envoyée avec succès");
                },
                function () {

                });
        }

        var addItemData = {
            templateUrl: 'app/admin/user-management/user-management-dialog.html',
            controller: 'UserManagementDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                vue: false,
                copy: null,
                entity: function () {
                    return {
                        id: null,
                        login: null,
                        firstName: null,
                        lastName: null,
                        email: null,
                        activated: true,
                        langKey: null,
                        createdBy: null,
                        createdDate: null,
                        lastModifiedBy: null,
                        lastModifiedDate: null,
                        resetDate: null,
                        resetKey: null,
                        authorities: null
                    };
                }
            }
        };


        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/admin/user-management/user-management-dialog.html',
            controller: 'UserManagementDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                vue: false,
                copy: null,
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
            controller: 'UserManagementDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function () {
            return {};
        };

        var entityParams = function () {
            return {};
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: User,
            entitySearch: User,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-tracker', {
            url: '/tracker',
            title:"Suivre les utilisateurs",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-eye-open',
                order: 91
            },            
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('josdaviApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'AuthServerProvider'];

    function JhiTrackerService($rootScope, $window, $cookies, $http, $q, AuthServerProvider) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var authToken = AuthServerProvider.getToken();
            console.log('--Tracker URL 1 : --', url);
            console.log('--Token tracker : --', authToken);
            /*if (authToken) {
                url += '?access_token=' + authToken.access_token;
            }*/
            console.log('--Tracker URL 2 : --', url);
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            stompClient.connect(headers, function () {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
            });
        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                        {},
                        angular.toJson({
                            'page': $rootScope.toState.name,
                            'platform': navigator.platform,
                            'userAgent': getBrowser(),
                            'appName': navigator.appName,
                            'vendor': navigator.vendor,
                            'language': navigator.language,
                            'appVersion': navigator.appVersion,
                            'onLine': navigator.onLine
                        }));
            }
        }

        function subscribe() {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/topic/tracker', function (data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-metrics', {
            url: '/metrics',
            title:"Métrics",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-dashboard',
                order: 92
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.logs', {
            url: '/logs',
            title:"Logs",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-tasks',
                order: 94
            },            
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-health', {
            url: '/health',
            title:"Diagnostiques",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-heart',
                order: 95
            },            
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('josdaviApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.entity-audit', {
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entity-audit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("entityAudit.result.firstAuditEntry");

            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) != "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin.docs', {
            url: '/docs',
            title:"API",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-book',
                order: 93
            },            
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-configuration', {
            url: '/configuration',
            title:"Configuration",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-list-alt',
                order: 96
            },            
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.audits', {
            url: '/audits',
            title:"Audits",
            sidebarMeta: {
                icon: 'glyphicon glyphicon-bell',
                order: 98
            },            
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app',
            title: 'Administration',
            data: {
                authorities: ['ROLE_ADMIN']
            }
        })
    }
})();
(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('josdaviApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-6"><div ba-panel ba-panel-title="Envoies par assistant et par mois" ba-panel-class="with-scroll "><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="vm.seriesIPA" chart-data="vm.datasIPA" chart-labels="vm.labelsIPA"></canvas></div></div></div><div class="col-md-6"><div ba-panel ba-panel-title="Envoies par \xE9tablissements et par mois" ba-panel-class="with-scroll "><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-series="vm.seriesIPE" chart-data="vm.datasIPE" chart-labels="vm.labelsIPE"></canvas></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/entity-audit/entity-audit.detail.html','<div class="modal-header"><button aria-label="{{ \'entityAudit.detail.close\' | translate }}" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" data-translate="entityAudit.detail.title">Audit Details</h4></div><div class="modal-body pad"><div><strong data-translate="entityAudit.detail.action" translate-value-action="{{vm.audit.action}}">{{vm.audit.action}} action was performed on below data</strong><br><br><del class="diff diff-key" data-translate="entityAudit.detail.old">Old/Removed value</del> &nbsp; <ins class="diff diff-key" data-translate="entityAudit.detail.new">New/Added value</ins></div><br><label data-translate="entityAudit.detail.changedFields">Changed Fields</label><pre id="resultChanges" ng-bind-html="vm.diffValueChanges"></pre><label data-translate="entityAudit.detail.allFields">All Fields</label><pre id="result" ng-bind-html="vm.diffValue"></pre></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default" type="button" ng-click="vm.cancel()" data-translate="entityAudit.detail.done">Done</button></div>');
$templateCache.put('app/admin/entity-audit/entity-audits.html','<div ng-cloak class="pad"><div class="row"><h3 class="col-sm-12" data-translate="entityAudit.home.title">Entity Audits</h3></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-12 pad"><h4 data-translate="entityAudit.home.filter">Filter</h4><form name="auditForm" role="form" novalidate show-validation><div class="row"><div class="col-md-8 form-group"><label data-translate="entityAudit.home.entityOrTable">Entity/Table</label><select class="input-sm form-control" name="qualifiedName" id="qualifiedName" required ng-options="vm.getEntityName(entity) for entity in vm.entities" ng-model="vm.qualifiedName"></select><div ng-show="auditForm.qualifiedName.$invalid"><p class="help-block" ng-show="auditForm.qualifiedName.$error.required" data-translate="entity.validation.required">This field is required</p></div></div><div class="col-md-4 form-group"><label data-translate="entityAudit.home.limitTo">Limit to</label><select class="input-sm form-control" name="limit" id="limit" required ng-options="option for option in vm.limits" ng-model="vm.limit"></select></div></div><div class="row pad"><button ng-disabled="auditForm.$invalid" class="btn btn-primary pull-right" ng-click="vm.loadChanges()"><i class="glyphicon glyphicon-import"></i>&nbsp; {{\'entityAudit.home.loadChangeList\' | translate}}</button></div></form></div></div><div ng-show="!vm.loading"><div class="table-responsive" ng-if="vm.audits.length > 0"><p ng-if="vm.qualifiedName" data-translate="entityAudit.result.showInfo" translate-value-limit="{{vm.limit}}" translate-value-entity="{{vm.getEntityName(vm.qualifiedName)}}">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class="form-inline"><div class="form-group"><label for="searchField" data-translate="entityAudit.result.searchFieldLabel">Filter:</label><input type="text" class="form-control" id="searchField" ng-model="filter.$" placeholder="{{ \'entityAudit.result.globalFilter\' | translate }}"></div><div class="form-group"><input type="text" class="form-control" id="searchFieldEntityId" ng-model="filter.entityId" placeholder="{{ \'entityAudit.result.entityIdFilter\' | translate }}"></div></form><table class="table table-bordered table-hover table-striped"><thead><tr><th data-translate="entityAudit.result.tableHeader.entityId">Entity Id</th><th data-translate="entityAudit.result.tableHeader.action">Action</th><th data-translate="entityAudit.result.tableHeader.version">Version</th><th data-translate="entityAudit.result.tableHeader.value">Value</th><th data-translate="entityAudit.result.tableHeader.modifiedDate">Modified Date</th><th data-translate="entityAudit.result.tableHeader.modifiedBy">Modified By</th><th><i class="glyphicon glyphicon-eye-open"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class="audit-obj" ng-bind-html="vm.format(audit.entityValue)"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class="no-pad">\n                        <div class="audit-obj">\n                            <table class="table table-bordered table-hover no-margin">\n                                <tr>\n                                    <th data-translate="entityAudit.result.tableBody.field">Field</th>\n                                    <th data-translate="entityAudit.result.tableBody.value">Value</th>\n                                </tr>\n                                <tr ng-repeat="(k,v) in audit.entityValue" ng-if="!vm.isObject(v)">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if="vm.isDate(k)">{{v | date:\'medium\'}}</span>\n                                        <span ng-if="!vm.isDate(k)">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type="button" ng-click="vm.openChange(audit)" uib-tooltip="{{ \'entityAudit.result.tableBody.viewDetails\' | translate }}" uib-tooltip-placement="auto" class="btn btn-info btn-xs"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div><p ng-if="vm.displayedChanges.length == 0" data-translate="entityAudit.result.noDataFound">No Data found for the filters</p></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time | date:\'yyyy-MM-dd HH:mm:ss\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><div class="form-group"><label class="control-label col-sm-4" for="field_photo">Photo</label><div class="col-sm-8"><div class="userpic"><div class="userpic-wrapper" ngf-select ngf-change="vm.setPhoto($file, vm.user)" accept="image/*"><img data-ng-src="{{\'data:\' + vm.user.photoContentType + \';base64,\' + vm.user.photo}}" ng-if="vm.user.photo" alt="Photo"></div><i class="ion-ios-close-outline" ng-click="vm.removePicture()" ng-if="!vm.noPicture"></i> <a href class="change-userpic" ng-click="vm.uploadPicture()">Charger...</a></div><input type="hidden" class="form-control" name="photo" id="field_photo" ng-model="vm.user.photo"> <input type="hidden" class="form-control" name="photoContentType" id="field_photoContentType" ng-model="vm.user.photoContentType"></div></div><div class="form-group pt5"><label mf-required class="control-label col-sm-4" data-translate="userManagement.login">Login</label><div class="col-sm-8"><input required type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="userManagement.firstName">First Name</label><div class="col-sm-8"><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="userManagement.lastName">Last Name</label><div class="col-sm-8"><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="userManagement.email">Email</label><div class="col-sm-8"><input required type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"></div></div><div class="form-group"><label for="activated" class="control-label col-sm-4"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label class="control-label col-sm-4" data-translate="userManagement.profiles">Profiles</label><div class="col-sm-8"><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="container-fluid"><div class="row mb15"><div class="no-padding-left col-xs-5"><button class="btn btn-primary" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down">Nouveau Compte</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} \xE9l\xE9ments par page <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="col-xs-4 text-center"><span class="h4"><u>Liste des Utilisateurs</u></span></div><!-- <div class="col-xs-4 no-padding-right">\n            <form name="searchForm" class="form-inline">\n                <div class="input-group pull-right mt5">\n                    <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Rechercher">\n                    <span  class="input-group-btn width-min">\n                        <button class="btn btn-info " ng-click="vm.search(vm.searchQuery)">\n                        <span class="glyphicon glyphicon-search"></span>\n                        </button>\n                    </span>\n                    <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                        <button class="btn btn-warning " ng-click="vm.clear()">\n                        <span class="glyphicon glyphicon-trash"></span>\n                        </button>\n                    </span>\n                </div>\n            </form>\n        </div> --></div><br><div class="row"><table class="table-responsive table table-striped"><thead><tr class="ba-table-header"><th ng-click="vm.sortBy(\'login\')"><span data-translate="userManagement.login">login</span> <span ng-if="vm.isCurrentColumn(\'login\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'email\')"><span data-translate="userManagement.email">Email</span> <span ng-if="vm.isCurrentColumn(\'email\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'langKey\')"><span data-translate="userManagement.langKey">Langue</span> <span ng-if="vm.isCurrentColumn(\'langKey\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th><span data-translate="userManagement.profiles">Profiles</span> <span ng-if="vm.isCurrentColumn(\'profiles\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'lastName\')"><span data-translate="userManagement.lastName">Nom</span> <span ng-if="vm.isCurrentColumn(\'lastName\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'firstName\')"><span data-translate="userManagement.firstName">Pr\xE9nom</span> <span ng-if="vm.isCurrentColumn(\'firstName\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'createdDate\')"><span data-translate="userManagement.createdDate">Cr\xE9\xE9 le</span> <span ng-if="vm.isCurrentColumn(\'createdDate\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'lastModifiedBy\')"><span data-translate="userManagement.lastModifiedBy">Modifi\xE9 par</span> <span ng-if="vm.isCurrentColumn(\'lastModifiedBy\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'lastModifiedDate\')"><span data-translate="userManagement.lastModifiedDate">Modifi\xE9 le</span> <span ng-if="vm.isCurrentColumn(\'lastModifiedDate\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right">Actions</th></tr></thead><tbody><tr ng-repeat="user in vm.datas track by user.id"><td>{{user.login}}</td><td>{{user.email}}</td><td>{{user.langKey}}</td><td><span ng-repeat="authority in user.authorities"><h6 class="label label-info">{{ authority }}</h6></span></td><td>{{user.lastName}}</td><td>{{user.firstName}}</td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.editItem($event,user)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button> <button type="submit" title="Renvoyer le mail d\'activation du compte" ng-click="vm.resendActivationItem($event,user)" class="btn btn-info btn-xs btn-round"><span class="glyphicon glyphicon-send"></span></button> <button type="submit" ng-click="vm.deleteItem($event,user)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-12"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><input type="text" class="form-control login-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><input type="password" class="form-control login-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><button type="submit" class="btn-block btn btn-primary" data-translate="login.form.button">Sign in</button></div></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/components/select/select-dialog.html','<div class="container-fluid"><div class="row"><div class="col-sm-12 mt15"><input type="text" placeholder="Rechercher..." class="form-control form-control-static" name="filter_field" ng-model="ctrl.query"></div><div class="col-sm-12 mf-select-table-container"><table class="table-responsive table table-hover"><caption></caption><thead><tr class="j-table-header"><th style="width:7%"><span ng-if="ctrl.multiple"><input ng-change="ctrl.toggleAll()" type="checkbox" class="form-control checkbox" ng-model="ctrl.allSelected"></span></th><th ng-repeat="(key, col) in ctrl.columns"><span>{{col.title}}</span></th></tr></thead><tbody><tr ng-repeat="item in ctrl.datas|filter:ctrl.query|orderBy:ctrl.columns[0]" ng-click="ctrl.toggle(item)"><td><input type="checkbox" class="form-control checkbox" ng-checked="ctrl.isChecked(item)"></td><td ng-repeat="(key, col) in ctrl.columns"><span title="{{item[col.name]}}">{{item[col.name]|characters:12}}</span></td></tr></tbody></table></div></div><div class="row p10"><div class="btn-group btn-group-xs pull-right"><button ng-click="ctrl.cancel()" class="btn btn-danger">Annuler</button> <button ng-if="ctrl.datas.length!=0" ng-click="ctrl.confirm()" class="btn btn-success"><span class="fa fa-check"></span>&nbsp;Valider</button></div></div></div>');
$templateCache.put('app/entities/info-administrative/info-admin.html','<div class="container-fluid"><div class="row-fluid"><div class="col-sm-2"></div><div class="col-sm-8"><fieldset class="j_fieldset p10"><legend>Informations</legend><form name="editForm" role="form" novalidate ng-submit="vm.send()" class="form-horizontal col-sm-12"><div class="form-group" ng-class="{\'has-error\':vm.hasError(editForm, editForm.sender)}"><label j-required class="control-label col-sm-2" for="contacts">Sender</label><div class="col-sm-10"><input required ng-model="vm.infos.sender" ng-maxlength="20" ng-minlength="2" class="form-control" id="sender" name="sender"></div></div><div class="form-group" ng-class="{\'has-error\':vm.hasError(editForm, editForm.contacts)}"><label j-required class="control-label col-sm-2" for="contacts">Contacts</label><div class="col-sm-10"><textarea required ng-model="vm.infos.contacts" placeholder="Saisissez les contacts s\xE9par\xE9s par des points virgules(;) sans l\'indicatif du pays(226)" rows="2" ng-maxlength="500" class="form-control" id="contacts" name="contacts" id="field_contacts">\n                            </textarea></div></div><div class="form-group" ng-class="{\'has-error\':vm.hasError(editForm, editForm.contenu)}"><label j-required class="control-label col-sm-2" for="field_contenu" title="Message">Msg</label><div class="col-sm-10"><textarea required ng-model="vm.infos.contenu" placeholder="Saisissez votre message.Utilisez #code ou #eleve pour ref\xE9rencer le code ou le nom de l\'\xE9l\xE8ve. Valide seulement pour les classes." rows="2" ng-maxlength="500" class="form-control" name="contenu" id="field_contenu">\n                            </textarea></div></div><div class="pull-right"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clear()">Annuler</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-send"></span>&nbsp;<span>Envoyer</span></button></div></form></fieldset></div></div></div>');
$templateCache.put('app/entities/message/messages.html','<div class="container-fluid"><div class="row mb5"><div class="no-padding-left col-xs-3"><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} \xE9l\xE9ments par page <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(50)">50 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(100)">100 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(200)">200 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(500)">500 \xE9l\xE9ments par page</a></li></ul></div></div><div class="col-xs-5 text-center"><span class="h4"><u>Accus\xE9s/Messages re\xE7us ({{vm.totalItems}})</u></span></div><div class="col-xs-4 no-padding-right"><div class="form-group"><label class="col-sm-4 control-label" for="telephone">T\xE9l\xE9phone</label><div class="col-sm-8"><input placeholder="70000000" id="telephone" type="text" class="form-control" name="telephone" ng-model="vm.telephone" ng-model-options="{debounce:5000}"></div></div><div class="form-group"><label class="col-sm-4 control-label" for="contenu">Contenu</label><div class="col-sm-8"><input placeholder="Message" id="contenu" type="text" class="form-control" name="contenu" ng-model="vm.contenu" ng-model-options="{debounce:5000}"></div></div><div class="form-group"><label class="col-sm-4 control-label" for="date">Date</label><div class="col-sm-8"><div class="input-group"><input placeholder="jj/mm/aaaa" id="date" type="text" class="form-control" name="date" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.date" show-button-bar="false" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row"><table class="table-responsive table table-striped"><thead><tr class="ba-table-header"><th ng-click="vm.sortBy(\'date\')"><span>Date</span> <span ng-if="vm.isCurrentColumn(\'date\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'telephone\')"><span>T\xE9l\xE9phone</span> <span ng-if="vm.isCurrentColumn(\'telephone\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'contenu\')"><span>Contenu</span> <span ng-if="vm.isCurrentColumn(\'contenu\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'statut\')"><span>Statut</span> <span ng-if="vm.isCurrentColumn(\'statut\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th></tr></thead><tbody><tr ng-repeat="activiteAssistant in vm.datas track by activiteAssistant.id"><td>{{activiteAssistant.date | date:\'dd/MM/yyyy \xE0 HH:mm\'}}</td><td>{{activiteAssistant.telephone}}</td><td title="{{activiteAssistant.contenu}}">{{activiteAssistant.contenu|characters:100}}</td><td>{{activiteAssistant.statut}}</td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div>');
$templateCache.put('app/entities/parametre/parametre-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.parametre.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p><span class="fa fa-warning text-danger"></span> Etes vous sure de vouloir supprimer ce paramm\xE8tres ? Cela peut perturber le fonctionnement de l\'application</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/parametre/parametre-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myParametreLabel">Edition d\'un parametre</h4></div><div class="modal-body"><div class="form-group"><label j-required class="control-label col-sm-3" for="field_type">Type</label><div class="col-sm-9"><select required class="form-control" name="type" ng-model="vm.parametre.type" id="field_type"><option value="SYSTEM">SYSTEM</option><option value="METIER">METIER</option><option value="AUTRE">AUTRE</option></select></div></div><div class="form-group"><label j-required class="control-label col-sm-3" for="field_nom">Nom</label><div class="col-sm-9"><input type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.parametre.nom" required ng-maxlength="65"></div></div><div class="form-group"><label j-required class="control-label col-sm-3" for="field_valeur">Valeur</label><div class="col-sm-9"><input type="text" class="form-control" name="nom" id="field_valeur" ng-model="vm.parametre.valeur" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/parametre/parametres.html','<div class="container-fluid well"><div class="row mb5"><div class="no-padding-left col-xs-4"><button class="btn btn-primary btn-sm" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} \xE9l\xE9ments par page <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="col-xs-5 text-center"><span class="h4"><u>Liste des parametres</u></span></div></div><div class="row"><table class="table-responsive table table-striped"><thead><tr class="ba-table-header"><th ng-click="vm.sortBy(\'type\')"><span>Type</span> <span ng-if="vm.isCurrentColumn(\'type\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'nom\')"><span>Nom</span> <span ng-if="vm.isCurrentColumn(\'nom\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'valeur\')"><span>Valeur</span> <span ng-if="vm.isCurrentColumn(\'valeur\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right">Actions</th></tr></thead><tbody><tr ng-repeat="parametre in vm.datas track by parametre.id"><td>{{parametre.type}}</td><td>{{parametre.nom}}</td><td>{{parametre.valeur}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" ng-click="vm.editItem($event,parametre)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="vm.deleteItem($event,parametre)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">Barka</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="abonnement" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.abonnement">Abonnement</span></a></li><li ui-sref-active="active"><a ui-sref="abscence-eleve" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.abscenceEleve">Abscence Eleve</span></a></li><li ui-sref-active="active"><a ui-sref="annee-scolaire" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.anneeScolaire">Annee Scolaire</span></a></li><li ui-sref-active="active"><a ui-sref="bulletin" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.bulletin">Bulletin</span></a></li><li ui-sref-active="active"><a ui-sref="classe" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.classe">Classe</span></a></li><li ui-sref-active="active"><a ui-sref="eleve" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.eleve">Eleve</span></a></li><li ui-sref-active="active"><a ui-sref="emploie-temps" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.emploieTemps">Emploie Temps</span></a></li><li ui-sref-active="active"><a ui-sref="etablissement" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.etablissement">Etablissement</span></a></li><li ui-sref-active="active"><a ui-sref="evaluation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.evaluation">Evaluation</span></a></li><li ui-sref-active="active"><a ui-sref="infos-eleve" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.infosEleve">Infos Eleve</span></a></li><li ui-sref-active="active"><a ui-sref="inscription" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.inscription">Inscription</span></a></li><li ui-sref-active="active"><a ui-sref="matiere" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.matiere">Matiere</span></a></li><li ui-sref-active="active"><a ui-sref="note" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.note">Note</span></a></li><li ui-sref-active="active"><a ui-sref="parent" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.parent">Parent</span></a></li><li ui-sref-active="active"><a ui-sref="periode" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.periode">Periode</span></a></li><li ui-sref-active="active"><a ui-sref="seance-cours" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.seanceCours">Seance Cours</span></a></li><li ui-sref-active="active"><a ui-sref="personne" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.personne">Personne</span></a></li><li ui-sref-active="active"><a ui-sref="user-extra" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.userExtra">User Extra</span></a></li><li ui-sref-active="active"><a ui-sref="ville" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ville">Ville</span></a></li><li ui-sref-active="active"><a ui-sref="responsabilite" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.responsabilite">Responsabilite</span></a></li><li ui-sref-active="active"><a ui-sref="activite-assistant" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.activiteAssistant">Activite Assistant</span></a></li><li ui-sref-active="active"><a ui-sref="activite-assistant" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.activiteAssistant">Activite Assistant</span></a></li><li ui-sref-active="active"><a ui-sref="note" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.note">Note</span></a></li><li ui-sref-active="active"><a ui-sref="importation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.importation">Importation</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li>Bienvenu : soufiane<li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.entity-audit">Entity Audit</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="mt125"><div class="row"><fieldset class="mt125 j_fieldset p10 col-md-8 col-md-offset-2"><legend>R\xE9initialiser votre mot de passe</legend><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation class="form-horizontal"><div class="form-group"><div class="col-sm-8"><input type="email" class="form-control input-lg" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right mr10" data-translate="reset.request.form.button">Reset</button><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div></div></form></fieldset></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" rightslimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in $menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> </a><a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }} </a><a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }} </a><a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a ui-sref="home" class="al-logo clearfix"><span>Kafyka|</span>SMS-API</a> <a href class="collapse-menu-link fa fa-navicon" ba-sidebar-toggle-menu></a><div class="search" data-ng-if="vm.isAuthenticated"><span>Bienvenu : </span><span class=""><b>{{vm.account.data.login}}</b></span></div><div class="user-profile clearfix pull-right"><div data-ng-if="vm.isAuthenticated" class="al-user-profile" uib-dropdown><a uib-dropdown-toggle class="profile-toggle-link"><span class="fa fa-user fa-3x"></span><!-- <img ng-src="{{::( profilePicture )}}"/> --></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu><li><i class="dropdown-arr"></i></li><li><a ui-sref="settings"><i class="fa fa-cog"></i>Mon profile</a></li><li><a ui-sref="password"><i class="fa fa-lock"></i>Mot de passe</a></li><li><a href="" data-ng-click="vm.logout()"><i class="fa fa-power-off"></i>D\xE9connexion</a></li></ul></div><div has-authority="ROLE_ADMIN" class="user-profile clearfix"><span ng-class="{active: vm.$state.includes(\'admin\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle btn-link" uib-dropdown-toggle href="" id="admin-menu"><span data-translate="global.menu.admin.main">Administration</span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="admin.user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="admin.audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="admin.logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="admin.docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></span></div><!-- <msg-center></msg-center> --><div class="user-profile"><ul class="al-share"><li>&nbsp;&nbsp;</li><li data-ng-if="!vm.isAuthenticated" class="btn-group btn-group-sm"><a class="btn-link" data-ng-click="vm.login()">Connexion</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown><a href uib-dropdown-toggle><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href>Mark All as Read</a> <a href>Settings</a></div><div class="msg-list"><a href class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image ||  (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href>See all notifications</a></div></li><li uib-dropdown><a href class="msg" uib-dropdown-toggle><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href>Mark All as Read</a> <a href>Settings</a></div><div class="msg-list"><a href class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href>See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"/><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"/><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);})();